import Seo from "../components/site/Seo";
import { MaskLines, Reveal } from "../components/site/Motion";
import { QuoteForm } from "../components/site/QuoteForm";
import { Faq } from "../components/site/Faq";
import { ZonesGrid } from "../components/site/ZonesGrid";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { COMPANY } from "../data/site";

const FAQ = [
  { q: "Le devis est-il gratuit ?", a: "Oui, le devis est gratuit et sans engagement. Le déplacement est inclus dans nos interventions en Gironde." },
  { q: "Quelles informations préparer pour le devis ?", a: "Votre commune, le type de lieu (maison, piscine, gîte, commerce…), une estimation de la surface extérieure et la gêne constatée (moustique tigre, soirées, journée)." },
  { q: "Dans quelles zones intervenez-vous ?", a: "À Bordeaux et dans toute la Gironde : Bordeaux Métropole, Libournais, Bassin d'Arcachon, Médoc et le reste du département." },
];

const Info = ({ icon: I, label, children, href, id }) => {
  const C = href ? "a" : "div";
  return (
    <C href={href} data-testid={id} className="group flex gap-4 rounded-2xl border border-moss/15 bg-white p-5 hover:border-moss/40 transition-colors">
      <span className="w-11 h-11 rounded-xl bg-moss text-lime grid place-items-center shrink-0"><I className="w-5 h-5" /></span>
      <span className="min-w-0"><span className="block text-xs font-bold uppercase tracking-[0.16em] text-sage">{label}</span><span className="block mt-1 font-display text-lg font-bold text-forest break-words group-hover:text-moss">{children}</span></span>
    </C>
  );
};

export default function Contact() {
  return (
    <main data-testid="page-contact" className="pt-32">
      <Seo title="Contact & devis gratuit anti-moustique | Bordeaux Gironde" description="Demandez votre devis anti-moustique gratuit à Bordeaux et en Gironde : 07 45 71 15 10, termitehabitat33@gmail.com ou formulaire en ligne. Réponse rapide." path="/contact" faq={FAQ} breadcrumb={[{ name: "Contact", path: "/contact" }]} />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 pb-20">
        <p className="eyebrow text-sage">Contact · Devis gratuit</p>
        <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-8xl font-extrabold leading-[0.9] tracking-[-0.04em] text-forest" data-testid="page-title">
          <MaskLines lines={["Parlons de", <span key="v" className="serif-i font-normal text-moss">votre extérieur.</span>]} />
        </h1>
        <div className="mt-14 grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <Reveal className="space-y-3">
            <p className="lead-text text-ink/75 mb-6 max-w-lg">Une question, une urgence avant un événement, ou simplement envie de profiter à nouveau de votre jardin ? Contactez Termite Habitat 33, votre spécialiste anti-moustique à Bordeaux et en Gironde.</p>
            <Info icon={Phone} label="Téléphone" href={COMPANY.phoneHref} id="contact-phone">{COMPANY.phone}</Info>
            <Info icon={Mail} label="Email" href={`mailto:${COMPANY.email}`} id="contact-email">{COMPANY.email}</Info>
            <Info icon={MapPin} label="Adresse" id="contact-address">{COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}</Info>
            <Info icon={Facebook} label="Facebook" href={COMPANY.facebook} id="contact-facebook">Termite Habitat 33</Info>
            <div className="overflow-hidden rounded-2xl border border-moss/15 mt-6 h-64">
              <iframe title="Localisation Termite Habitat 33 à Parempuyre" loading="lazy" className="w-full h-full" src="https://www.google.com/maps?q=53+avenue+de+la+for%C3%AAt+d%27Arboudeau+33290+Parempuyre&output=embed" />
            </div>
          </Reveal>
          <Reveal delay={0.1}><QuoteForm /></Reveal>
        </div>
      </section>
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 pb-10">
        <h2 className="h2 text-forest mb-10">Nos secteurs d'intervention</h2>
        <ZonesGrid />
      </section>
      <Faq items={FAQ} />
    </main>
  );
}
